import './searchable-drop-down.scss'

import { ReactiveVue } from '@skinsoft/reactive-vue'
import { Observable } from 'rxjs'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

export const SEARCHABLE_DROPDOWN_ITEM_SELECTED = 'searchable-drop-down-item-selected'
export const SEARCHABLE_DROPDOWN_SELECTED_ITEMS_CHANGED =
    'searchable-drop-down-selected-items-changed'

export interface SearchableDropDownItem {
    id: string
    text: string
}

export interface SearchableDropDownSearchResult {
    items: SearchableDropDownItem[],
    nbPages: number,
}

@Component({
    components: {},
    props: ['searchFunction', 'multipleSelection', 'pageSize'],
    template: require('./searchable-drop-down.html'),
})
export default class SearchableDropDown extends ReactiveVue {
    private searchFunction: (
        text: string,
        page?: number,
        size?: number,
        excludedItems?: SearchableDropDownItem[],
    ) => Observable<SearchableDropDownSearchResult>
    private multipleSelection: boolean
    private pageSize: number

    private items: SearchableDropDownItem[] = []
    private selectedItem: SearchableDropDownItem = { id: '', text: '' }
    private selectedItems: SearchableDropDownItem[] = []
    private searchText: string = ''
    private open: boolean = false

    private currentPageNumber: number = 1
    private nbPages: number = NaN

    private searchIcon = faSearch
    private removeIcon = faTimes

    private mounted() {
        this.search()
    }

    private search() {
        this.searchFunction(
            this.searchText,
            this.currentPageNumber-1,
            this.pageSize,
            this.multipleSelection ? this.selectedItems : undefined,
        ).subscribe(({ items, nbPages }) => {
            this.items = items
            this.nbPages = nbPages
        })
    }

    private onItemSelected(item: SearchableDropDownItem) {
        if (this.multipleSelection) {
            this.selectedItems.push(item)
            this.$emit(SEARCHABLE_DROPDOWN_SELECTED_ITEMS_CHANGED, this.selectedItems)
            this.currentPageNumber = 1
            this.search()
        } else {
            this.selectedItem = item
            this.$emit(SEARCHABLE_DROPDOWN_ITEM_SELECTED, item)
        }
        this.open = !this.open
        this.searchText = ''
    }

    private onRemoveItem(index: number) {
        this.selectedItems.splice(index, 1)
        this.search()
    }

    private incrementPageNumber() {
        if(this.currentPageNumber < this.nbPages) {
            this.currentPageNumber++
            this.search()
        }
    }

    private decrementPageNumber() {
        if(this.currentPageNumber > 1) {
            this.currentPageNumber--
            this.search()
        }
    }

    private goToPage(page: number) {
        if(1 <= page && page <= this.nbPages && page !== this.currentPageNumber ) {
            this.currentPageNumber = page
            this.search()
        }
    }

    @Watch('searchText')
    private onFilterTextChange() {
        this.currentPageNumber = 1
        this.search()
    }
}